export default "__VITE_ASSET__2eb4961a__"